import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import App from "./App";
import { getEnvironment } from "./lib/env";
import "./styles/globals.css";

// Disabled in local development, matching the backend (cmd/webserver.go).
const environment = getEnvironment();
if (environment !== "local") {
  Sentry.init({
    dsn: "https://7789b9a8ffc5686577b79ef15ec34cc4@o4510028147982336.ingest.de.sentry.io/4512202643734608",
    environment,
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
